import axios from 'axios';

//convert time
export const convertTime = (time) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
};

//verify account number

export const verifyAccount = async (data) => {
  const response = await axios.post(
    `https://api.flutterwave.com/v3/accounts/resolve
    `,
    { account_number: '0690000032', account_bank: '044' },
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer FLWSECK_TEST-dd0eb3a583419b631a2638d1a66acc53-X`,
      },
    }
  );

  console.log(response);
  return response.data;
};

export function formatArrayToString(arr) {
  const formattedArray = arr
    .slice(0, 3) // Take the first 7 items
    .join(', '); // Join with commas

  let remaining = arr.length - 3;

  return arr.length > 3
    ? formattedArray + ` and ${remaining} more `
    : formattedArray;
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
    /* you can also use 'auto' behaviour
       in place of 'smooth' */
  });
};
